import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Builders } from '../../features/builders/builders.tsx';
import useAppStore from '../../store/rootStore.ts';
import { createPageBackgroundSx } from '../../styles/pageBackground.ts';

export const Route = createFileRoute('/builders/')({
  component: BuildersPage,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.showBuildersFundingHistory) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const buildersPageSx = createPageBackgroundSx();

function BuildersPage() {
  return (
    <Stack sx={buildersPageSx}>
      <Builders />
    </Stack>
  );
}
